const API_BASE = "/api";

const authSection = document.getElementById("auth-section");
const wordsSection = document.getElementById("words-section");
const loginForm = document.getElementById("login-form");
const loginMessage = document.getElementById("login-message");
const addWordForm = document.getElementById("add-word-form");
const wordsList = document.getElementById("watched-words-list");
const logoutBtn = document.getElementById("logout-btn");
const llmSummaryToggle = document.getElementById("llm-summary-toggle");
const weeklyDigestToggle = document.getElementById("weekly-digest-toggle");
const savedSearchesList = document.getElementById("saved-searches-list");
const committeeSubsList = document.getElementById("committee-subs-list");
const kommuneSelect = document.getElementById("kommune-select");
const gremienPanel = document.getElementById("gremien-panel");
const gremienList = document.getElementById("gremien-list");
const gremienFilter = document.getElementById("gremien-filter");
const kommuneAllToggle = document.getElementById("kommune-all");
const kommuneAllName = document.getElementById("kommune-all-name");
const inactiveToggle = document.getElementById("gremien-inactive-toggle");
const committeeStatus = document.getElementById("committee-status");
const topicList = document.getElementById("topic-list");
const topicStatus = document.getElementById("topic-status");
const loginLayout = document.getElementById("konto-login-layout");
const loginSubmit = document.getElementById("login-submit");
const accountLine = document.getElementById("konto-account");
const lede = document.getElementById("konto-lede");
const settingsStatus = document.getElementById("settings-status");
const LEDE_LOGGED_OUT = lede ? lede.textContent : "";

// Check for Magic Link token in URL
const urlParams = new URLSearchParams(window.location.search);
const tokenFromUrl = urlParams.get("token");

if (tokenFromUrl) {
  fetch(`${API_BASE}/auth/session`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({ token: tokenFromUrl }),
  }).finally(() => {
    window.history.replaceState({}, document.title, "/konto");
    updateUI();
  });
}

async function apiRequest(endpoint, method = "GET", body = null) {
  const headers = { "Content-Type": "application/json" };

  const response = await fetch(`${API_BASE}${endpoint}`, {
    method,
    headers,
    credentials: "same-origin",
    body: body ? JSON.stringify(body) : null,
  });

  if (response.status === 401) {
    updateUI();
    return null;
  }
  // Manche Endpunkte (z. B. /settings) antworten nur mit Status, ohne JSON.
  const type = response.headers.get("content-type") || "";
  if (!type.includes("application/json")) return response.ok ? {} : null;
  return response.json();
}

// --- Themen ---

const topics = {
  names: [],
  subs: [], // [{ themengruppe, sessions, documents, kommunen }]
  kommunen: [],
  openIndex: null, // aufgeklappte Kommunen-Auswahl
};

let topicStatusTimer = null;
function showTopicStatus(text, isError = false) {
  if (!topicStatus) return;
  topicStatus.textContent = text;
  topicStatus.classList.toggle("is-error", isError);
  clearTimeout(topicStatusTimer);
  if (!isError) {
    topicStatusTimer = setTimeout(() => {
      topicStatus.textContent = "";
    }, 2500);
  }
}

function topicSub(name) {
  return (
    topics.subs.find((s) => s.themengruppe === name) || {
      themengruppe: name,
      sessions: false,
      documents: false,
      kommunen: [],
    }
  );
}

async function saveTopic(next, focusId) {
  const result = await apiRequest("/topic-subscriptions", "PUT", next);
  if (!result) {
    showTopicStatus("Speichern hat nicht geklappt.", true);
  } else {
    topics.subs = result;
    showTopicStatus("Gespeichert.");
  }
  renderTopics();
  if (focusId) document.getElementById(focusId)?.focus();
}

function describeKommunen(list) {
  if (!list.length) return "In allen Kommunen";
  if (list.length <= 2) return `Nur in ${list.join(" und ")}`;
  return `Nur in ${list.length} Kommunen`;
}

function topicCheckbox(id, text, checked, onChange) {
  const label = document.createElement("label");
  label.className = "themen-toggle";
  const cb = document.createElement("input");
  cb.type = "checkbox";
  cb.id = id;
  cb.checked = checked;
  cb.addEventListener("change", () => onChange(cb.checked));
  const span = document.createElement("span");
  span.textContent = text;
  label.append(cb, span);
  return label;
}

function renderTopicKommunen(sub, index) {
  const details = document.createElement("details");
  details.className = "themen-kommunen";
  // Offen lassen, solange hier gerade gearbeitet wird.
  if (topics.openIndex === index) details.open = true;
  details.addEventListener("toggle", () => {
    if (details.open) topics.openIndex = index;
    else if (topics.openIndex === index) topics.openIndex = null;
  });
  const summary = document.createElement("summary");
  summary.textContent = describeKommunen(sub.kommunen);
  details.appendChild(summary);

  const hint = document.createElement("p");
  hint.className = "themen-kommunen-hint";
  hint.textContent = "Keine Auswahl heißt: alle Kommunen.";
  const grid = document.createElement("div");
  grid.className = "themen-kommunen-grid";
  topics.kommunen.forEach((kommune, k) => {
    grid.appendChild(
      topicCheckbox(
        `topic-${index}-k${k}`,
        kommune,
        sub.kommunen.includes(kommune),
        (checked) => {
          const kommunen = checked
            ? [...sub.kommunen, kommune]
            : sub.kommunen.filter((x) => x !== kommune);
          saveTopic({ ...sub, kommunen }, `topic-${index}-k${k}`);
        }
      )
    );
  });
  details.append(hint, grid);
  return details;
}

function renderTopics() {
  if (!topicList) return;
  topicList.replaceChildren(
    ...topics.names.map((name, index) => {
      const sub = topicSub(name);
      const active = sub.sessions || sub.documents;
      const li = document.createElement("li");
      li.className = active ? "themen-item is-active" : "themen-item";
      const title = document.createElement("span");
      title.className = "themen-name";
      title.textContent = name;
      const toggles = document.createElement("div");
      toggles.className = "themen-toggles";
      toggles.setAttribute("role", "group");
      toggles.setAttribute("aria-label", name);
      toggles.append(
        topicCheckbox(
          `topic-${index}-s`,
          "Neue Sitzungen",
          sub.sessions,
          (checked) =>
            saveTopic({ ...sub, sessions: checked }, `topic-${index}-s`)
        ),
        topicCheckbox(
          `topic-${index}-d`,
          "Neue Dokumente",
          sub.documents,
          (checked) =>
            saveTopic({ ...sub, documents: checked }, `topic-${index}-d`)
        )
      );
      li.append(title, toggles);
      if (active) li.appendChild(renderTopicKommunen(sub, index));
      return li;
    })
  );
}

async function loadTopicKommunen() {
  try {
    const res = await fetch("/api/calendar/municipalities");
    if (res.ok) topics.kommunen = await res.json();
  } catch {
    topics.kommunen = [];
  }
  renderTopics();
}

// --- Gremien ---

// Gremien ohne Sitzung in diesem Zeitraum gelten als ruhend und sind eingeklappt.
const INACTIVE_AFTER_MS = 2 * 365 * 24 * 60 * 60 * 1000;
// Erst ab dieser Zahl lohnt das Filterfeld über der Liste.
const FILTER_FROM = 12;
// Gruppen nach Art des Gremiums, in Anzeigereihenfolge. Die Themengruppen taugen
// dafür nicht: „Rat“ oder „Schulausschuss“ treffen keines ihrer Stichwörter,
// viele Fachausschüsse dagegen drei auf einmal. Zugeordnet wird über das erste
// passende Muster in MATCH_ORDER, der Rest sind Fachausschüsse.
const GROUPS = {
  rat: "Rat und Verwaltungsausschuss",
  fach: "Fachausschüsse und Beiräte",
  ortsrat: "Ortsräte",
  einwohner: "Einwohnerversammlungen",
  weitere: "Weitere Termine",
};
const MATCH_ORDER = [
  [
    "rat",
    /^(?:rat|stadtrat|gemeinderat|samtgemeinderat|kreistag|kreisausschuss|verwaltungsausschuss|samtgemeindeausschuss|hauptausschuss)\b/i,
  ],
  ["ortsrat", /\bortsr(?:at|äte)\b/i],
  ["einwohner", /^einwohn\w*versammlung/i],
  ["weitere", /(?:wahl|versammlung|gespräch|konferenz)\b/i],
];

const committees = {
  overview: null, // { kommunen: [{ kommune, gremien }] }
  subs: [],
  kommuneSubs: [],
  kommune: "",
  query: "",
  showInactive: false,
};

async function loadCommitteeOverview() {
  try {
    const res = await fetch("/api/calendar/committee-overview");
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    committees.overview = await res.json();
  } catch {
    committees.overview = null;
    showCommitteeStatus("Die Gremien konnten nicht geladen werden.", true);
    return;
  }
  // Erste Option „Kommune wählen …“ behalten, Rest bei erneutem Laden ersetzen.
  while (kommuneSelect.options.length > 1) kommuneSelect.remove(1);
  committees.overview.kommunen.forEach(({ kommune, gremien }) => {
    const opt = document.createElement("option");
    opt.value = kommune;
    opt.textContent = `${kommune} (${gremien.length} Gremien)`;
    kommuneSelect.appendChild(opt);
  });
  // Ohne Auswahl die Kommune öffnen, in der schon Abos bestehen.
  if (!committees.kommune) {
    const known = new Set(committees.overview.kommunen.map((k) => k.kommune));
    committees.kommune =
      [...committees.kommuneSubs, ...committees.subs]
        .map((s) => s.kommune)
        .find((k) => known.has(k)) || "";
  }
  kommuneSelect.value = committees.kommune;
  renderGremienPicker();
}

let committeeStatusTimer = null;
function showCommitteeStatus(text, isError = false) {
  if (!committeeStatus) return;
  committeeStatus.textContent = text;
  committeeStatus.classList.toggle("is-error", isError);
  clearTimeout(committeeStatusTimer);
  if (!isError) {
    committeeStatusTimer = setTimeout(() => {
      committeeStatus.textContent = "";
    }, 2500);
  }
}

function formatDay(iso) {
  return new Date(iso).toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: "Europe/Berlin",
  });
}

function isInactive(g) {
  if (g.next) return false;
  return !g.last || Date.now() - new Date(g.last).getTime() > INACTIVE_AFTER_MS;
}

function groupOf(g) {
  return MATCH_ORDER.find(([, re]) => re.test(g.gremium))?.[0] || "fach";
}

// Abo, das dieses Gremium abdeckt: eigenes für die Kommune oder ein altes
// Abo ohne Kommune („in allen Kommunen“).
function subFor(g) {
  return committees.subs.find((s) => s.gremium_key === g.key);
}
function anyKommuneSubFor(g) {
  return committees.subs.find((s) => !s.kommune && s.gremium_key === g.any_key);
}

async function toggleGremium(g, checked) {
  const kommune = committees.kommune;
  const sub = subFor(g);
  const result = checked
    ? await apiRequest("/committee-subscriptions", "POST", {
        gremium: g.gremium,
        kommune,
      })
    : sub
      ? await apiRequest(`/committee-subscriptions/${sub.id}`, "DELETE")
      : committees.subs;
  if (!result) {
    showCommitteeStatus("Speichern hat nicht geklappt.", true);
    renderGremienPicker();
    return;
  }
  committees.subs = result;
  showCommitteeStatus(
    checked
      ? `${g.gremium} (${kommune}) abonniert.`
      : `${g.gremium} (${kommune}) abbestellt.`
  );
  renderCommittees({ focusKey: g.key });
}

async function toggleKommune(kommune, checked) {
  const sub = committees.kommuneSubs.find((s) => s.kommune === kommune);
  const result = checked
    ? await apiRequest("/kommune-subscriptions", "POST", { kommune })
    : sub
      ? await apiRequest(`/kommune-subscriptions/${sub.id}`, "DELETE")
      : committees.kommuneSubs;
  if (!result) {
    showCommitteeStatus("Speichern hat nicht geklappt.", true);
    renderGremienPicker();
    return;
  }
  committees.kommuneSubs = result;
  showCommitteeStatus(
    checked
      ? `Alle Sitzungen in ${kommune} abonniert.`
      : `Alle Sitzungen in ${kommune} abbestellt.`
  );
  renderCommittees();
}

function renderGremienItem(g) {
  const sub = subFor(g);
  const anySub = anyKommuneSubFor(g);
  const label = document.createElement("label");
  label.className = "gremien-item";
  const cb = document.createElement("input");
  cb.type = "checkbox";
  cb.dataset.key = g.key;
  cb.checked = !!(sub || anySub);
  // Ein Abo „in allen Kommunen“ lässt sich nur oben in der Übersicht abbestellen.
  cb.disabled = !sub && !!anySub;
  cb.addEventListener("change", () => {
    cb.disabled = true;
    toggleGremium(g, cb.checked);
  });
  const text = document.createElement("span");
  text.className = "gremien-item-text";
  const name = document.createElement("span");
  name.className = "gremien-item-name";
  name.textContent = g.gremium;
  const meta = document.createElement("small");
  meta.className = "gremien-item-meta";
  meta.textContent = [
    g.next
      ? `nächste Sitzung ${formatDay(g.next)}`
      : g.last
        ? `zuletzt ${formatDay(g.last)}`
        : "",
    !sub && anySub ? "abonniert für alle Kommunen" : "",
  ]
    .filter(Boolean)
    .join(" · ");
  text.append(name, meta);
  label.append(cb, text);
  return label;
}

function renderGremienPicker({ focusKey } = {}) {
  const data = committees.overview?.kommunen.find(
    (k) => k.kommune === committees.kommune
  );
  gremienPanel.hidden = !data;
  if (!data) return;

  kommuneAllName.textContent = data.kommune;
  kommuneAllToggle.checked = committees.kommuneSubs.some(
    (s) => s.kommune === data.kommune
  );
  kommuneAllToggle.disabled = false;
  gremienFilter.hidden = data.gremien.length < FILTER_FROM;
  if (gremienFilter.hidden) committees.query = "";
  gremienFilter.value = committees.query;

  const needle = committees.query.trim().toLocaleLowerCase("de");
  const matching = data.gremien.filter(
    (g) => !needle || g.gremium.toLocaleLowerCase("de").includes(needle)
  );
  // Abonnierte Gremien bleiben sichtbar, auch wenn sie ruhen.
  const hidden = matching.filter(
    (g) => isInactive(g) && !subFor(g) && !anyKommuneSubFor(g)
  );
  const visible = committees.showInactive
    ? matching
    : matching.filter((g) => !hidden.includes(g));

  const groups = new Map(Object.keys(GROUPS).map((id) => [id, []]));
  visible.forEach((g) => groups.get(groupOf(g)).push(g));

  const nodes = [];
  for (const [id, items] of groups) {
    if (!items.length) continue;
    const section = document.createElement("div");
    section.className = "gremien-group";
    const h = document.createElement("h3");
    h.className = "gremien-group-title";
    h.textContent = GROUPS[id];
    section.appendChild(h);
    items.forEach((g) => section.appendChild(renderGremienItem(g)));
    nodes.push(section);
  }
  if (!nodes.length) {
    const p = document.createElement("p");
    p.className = "gremien-empty";
    p.textContent = needle
      ? `Kein Gremium in ${data.kommune} passt zu „${committees.query.trim()}“.`
      : "Hier sind nur ruhende Gremien eingetragen.";
    nodes.push(p);
  }
  gremienList.replaceChildren(...nodes);
  gremienList.classList.toggle("is-covered", kommuneAllToggle.checked);

  inactiveToggle.hidden = hidden.length === 0;
  inactiveToggle.textContent = committees.showInactive
    ? "Ruhende Gremien ausblenden"
    : hidden.length === 1
      ? "1 ruhendes Gremium anzeigen (keine Sitzung seit zwei Jahren)"
      : `${hidden.length} ruhende Gremien anzeigen (keine Sitzung seit zwei Jahren)`;

  if (focusKey) {
    gremienList
      .querySelector(`input[data-key="${CSS.escape(focusKey)}"]`)
      ?.focus();
  }
}

function makeChip(text, accessibleName, onRemove) {
  const btn = document.createElement("button");
  btn.type = "button";
  btn.className = "gremien-chip";
  btn.textContent = `${text} ×`;
  btn.setAttribute("aria-label", accessibleName);
  btn.addEventListener("click", async () => {
    btn.disabled = true;
    await onRemove();
  });
  return btn;
}

// Übersicht oben: was abonniert ist, nach Kommune gebündelt.
function renderCommitteeOverviewList() {
  const byKommune = new Map();
  const group = (kommune) => {
    if (!byKommune.has(kommune))
      byKommune.set(kommune, { all: null, gremien: [] });
    return byKommune.get(kommune);
  };
  committees.kommuneSubs.forEach((s) => (group(s.kommune).all = s));
  committees.subs.forEach((s) => group(s.kommune || "").gremien.push(s));

  if (byKommune.size === 0) {
    committeeSubsList.replaceChildren(
      makeEmptyItem("Noch keine Gremien abonniert.")
    );
    return;
  }
  const kommunen = [...byKommune.keys()].sort((a, b) =>
    !a ? 1 : !b ? -1 : a.localeCompare(b, "de")
  );
  committeeSubsList.replaceChildren(
    ...kommunen.map((kommune) => {
      const { all, gremien } = byKommune.get(kommune);
      const li = document.createElement("li");
      li.className = "word-item gremien-abo";
      const head = kommune
        ? document.createElement("button")
        : document.createElement("span");
      head.className = "word-label gremien-abo-kommune";
      head.textContent = kommune || "In allen Kommunen";
      if (kommune) {
        head.type = "button";
        head.title = `Gremien in ${kommune} bearbeiten`;
        head.addEventListener("click", () => selectKommune(kommune, true));
      }
      const chips = document.createElement("div");
      chips.className = "gremien-chips";
      if (all) {
        chips.appendChild(
          makeChip(
            "Alle Sitzungen",
            `Alle Sitzungen in ${kommune} abbestellen`,
            () => toggleKommune(kommune, false)
          )
        );
      }
      gremien
        .sort((a, b) => a.gremium.localeCompare(b.gremium, "de"))
        .forEach((s) => {
          chips.appendChild(
            makeChip(
              s.gremium,
              `${s.gremium} ${kommune ? "in " + kommune : "in allen Kommunen"} abbestellen`,
              async () => {
                const subs = await apiRequest(
                  `/committee-subscriptions/${s.id}`,
                  "DELETE"
                );
                if (subs) committees.subs = subs;
                renderCommittees();
              }
            )
          );
        });
      li.append(head, chips);
      return li;
    })
  );
}

function renderCommittees(options) {
  renderCommitteeOverviewList();
  renderGremienPicker(options);
}

function selectKommune(kommune, focus = false) {
  committees.kommune = kommune;
  committees.query = "";
  committees.showInactive = false;
  kommuneSelect.value = kommune;
  renderGremienPicker();
  if (focus) kommuneSelect.focus();
}

kommuneSelect.addEventListener("change", () =>
  selectKommune(kommuneSelect.value)
);
kommuneAllToggle.addEventListener("change", () => {
  kommuneAllToggle.disabled = true;
  toggleKommune(committees.kommune, kommuneAllToggle.checked);
});
gremienFilter.addEventListener("input", () => {
  committees.query = gremienFilter.value;
  renderGremienPicker();
});
inactiveToggle.addEventListener("click", () => {
  committees.showInactive = !committees.showInactive;
  renderGremienPicker();
});

async function updateUI() {
  const me = await fetch(`${API_BASE}/auth/me`, {
    credentials: "same-origin",
  })
    .then((res) => (res.ok ? res.json() : null))
    .catch(() => null);
  // Anmeldung und die Erklärung "Wofür brauche ich ein Konto?" sind nur für
  // Abgemeldete relevant; die Einstellungen nur für Angemeldete.
  const whySection = document.getElementById("konto-why");
  if (whySection) whySection.hidden = !!me;
  if (loginLayout) loginLayout.hidden = !!me;
  renderAccount(me);
  if (me) {
    authSection.hidden = true;
    wordsSection.hidden = false;
    const data = await apiRequest("/user-data");
    if (data) {
      renderWords(data.words);
      llmSummaryToggle.checked = data.llmSummary;
      weeklyDigestToggle.checked = data.weeklyDigest;
      renderSavedSearches(data.savedSearches || []);
      committees.subs = data.committeeSubscriptions || [];
      committees.kommuneSubs = data.kommuneSubscriptions || [];
      renderCommitteeOverviewList();
      topics.names = data.themengruppen || [];
      topics.subs = data.topicSubscriptions || [];
      renderTopics();
    }
    await Promise.all([loadCommitteeOverview(), loadTopicKommunen()]);
  } else {
    authSection.hidden = false;
    wordsSection.hidden = true;
  }
}

function renderAccount(me) {
  if (lede) {
    lede.textContent = me
      ? "Hier legst du fest, worüber wir dich per E-Mail informieren."
      : LEDE_LOGGED_OUT;
  }
  if (!accountLine) return;
  accountLine.replaceChildren();
  if (me && me.email) {
    const strong = document.createElement("strong");
    strong.textContent = me.email;
    accountLine.append("Angemeldet als ", strong);
  }
}

let settingsStatusTimer = null;
function showSettingsStatus(text, isError = false) {
  if (!settingsStatus) return;
  settingsStatus.textContent = text;
  settingsStatus.classList.toggle("is-error", isError);
  clearTimeout(settingsStatusTimer);
  if (!isError) {
    settingsStatusTimer = setTimeout(() => {
      settingsStatus.textContent = "";
    }, 2500);
  }
}

async function saveSetting(body) {
  try {
    const ok = await apiRequest("/settings", "POST", body);
    if (ok) showSettingsStatus("Gespeichert.");
    else showSettingsStatus("Speichern hat nicht geklappt.", true);
  } catch {
    showSettingsStatus("Speichern hat nicht geklappt.", true);
  }
}

llmSummaryToggle.addEventListener("change", (e) => {
  saveSetting({ llmSummary: e.target.checked });
});

weeklyDigestToggle.addEventListener("change", (e) => {
  saveSetting({ weeklyDigest: e.target.checked });
});

function setLoginMessage(text, kind) {
  loginMessage.textContent = text;
  loginMessage.className = kind ? `is-${kind}` : "";
}

loginForm.addEventListener("submit", async (e) => {
  e.preventDefault();
  const email = document.getElementById("email").value.trim();
  if (!email) return;
  if (loginSubmit) loginSubmit.disabled = true;
  setLoginMessage("Link wird verschickt …", "pending");
  try {
    const res = await fetch(`${API_BASE}/auth/magic-link`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ email }),
    });
    if (res.ok) {
      setLoginMessage(
        `Wir haben dir einen Anmeldelink an ${email} geschickt. Bitte prüfe dein Postfach.`,
        "ok"
      );
    } else if (res.status === 429) {
      setLoginMessage(
        "Zu viele Versuche. Bitte warte ein paar Minuten und versuche es dann noch einmal.",
        "error"
      );
    } else if (res.status === 400) {
      setLoginMessage("Bitte gib eine gültige E-Mail-Adresse ein.", "error");
    } else {
      setLoginMessage(
        "Der Link konnte gerade nicht verschickt werden. Bitte versuche es später noch einmal.",
        "error"
      );
    }
  } catch {
    setLoginMessage(
      "Keine Verbindung zum Server. Bitte versuche es später noch einmal.",
      "error"
    );
  } finally {
    if (loginSubmit) loginSubmit.disabled = false;
  }
});

addWordForm.addEventListener("submit", async (e) => {
  e.preventDefault();
  const input = document.getElementById("new-word");
  const word = input.value.trim();
  if (word) {
    const words = await apiRequest("/words", "POST", { word });
    input.value = "";
    if (words) renderWords(words);
  }
});

window.removeWord = async (word) => {
  const words = await apiRequest("/words", "DELETE", { word });
  if (words) renderWords(words);
};

window.deleteSavedSearch = async (id) => {
  const searches = await apiRequest(`/saved-searches/${id}`, "DELETE");
  renderSavedSearches(searches || []);
};

function makeRemoveButton(accessibleName, onRemove) {
  const btn = document.createElement("button");
  btn.type = "button";
  btn.className = "remove-btn";
  btn.textContent = "Entfernen";
  btn.setAttribute("aria-label", accessibleName);
  btn.addEventListener("click", onRemove);
  return btn;
}

// Eine Listenzeile: Bezeichnung (Text oder Link), optional eine Zusatzzeile,
// rechts der Entfernen-Knopf.
function makeWordItem(labelText, onRemove, { href, meta } = {}) {
  const li = document.createElement("li");
  li.className = "word-item";
  const main = document.createElement("span");
  main.className = "word-main";
  const label = document.createElement(href ? "a" : "span");
  label.className = "word-label";
  if (href) label.href = href;
  label.textContent = labelText;
  main.appendChild(label);
  if (meta) {
    const small = document.createElement("span");
    small.className = "word-meta";
    small.textContent = meta;
    main.appendChild(small);
  }
  li.appendChild(main);
  li.appendChild(makeRemoveButton(`„${labelText}“ entfernen`, onRemove));
  return li;
}

function makeEmptyItem(text) {
  const li = document.createElement("li");
  li.className = "word-item word-empty";
  li.textContent = text;
  return li;
}

function renderWords(words) {
  while (wordsList.firstChild) wordsList.removeChild(wordsList.firstChild);
  if (!words.length) {
    wordsList.appendChild(makeEmptyItem("Noch keine Begriffe."));
    return;
  }
  words.forEach((word) => {
    wordsList.appendChild(makeWordItem(word, () => window.removeWord(word)));
  });
}

// Kurzbeschreibung einer gespeicherten Suche aus ihrem Query-String.
function describeQuery(query) {
  try {
    const params = new URLSearchParams(query || "");
    const q = (params.get("q") || "").trim();
    let filters = 0;
    for (const key of new Set(params.keys())) {
      if (key !== "q" && key !== "page") filters += 1;
    }
    const parts = [];
    if (q) parts.push(`Suchbegriff „${q}“`);
    if (filters) parts.push(filters === 1 ? "1 Filter" : `${filters} Filter`);
    return parts.join(" · ");
  } catch {
    return "";
  }
}

function renderSavedSearches(searches) {
  while (savedSearchesList.firstChild)
    savedSearchesList.removeChild(savedSearchesList.firstChild);
  if (!searches.length) {
    savedSearchesList.appendChild(
      makeEmptyItem("Noch keine gespeicherten Suchen.")
    );
    return;
  }
  searches.forEach((s) => {
    // s.query ist der gespeicherte window.location.search (beginnt mit "?").
    savedSearchesList.appendChild(
      makeWordItem(s.name, () => window.deleteSavedSearch(s.id), {
        href: "/suche" + s.query,
        meta: describeQuery(s.query),
      })
    );
  });
}

logoutBtn.addEventListener("click", async () => {
  await fetch(`${API_BASE}/auth/logout`, {
    method: "POST",
    credentials: "same-origin",
  });
  await updateUI();
  document.getElementById("email")?.focus();
});

updateUI();
